<app-form-manager
    *ngIf="params"
    formPlugin="core-person-form"
    [params]="params"
    (canceled)="cancel($event)"
    #form>
</app-form-manager>
